import React, { useEffect, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";
const MSMERegistration = () => {

  
  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="service-page">

      {/* SEO */}
      <Helmet>
        <title>MSME Registration (Udyam) Service in India | Apply Online</title>

        <meta
          name="description"
          content="Get MSME (Udyam) registration online in India with expert support. Avail subsidies, loans, and government benefits easily."
        />

        <meta
          name="keywords"
          content="MSME registration, Udyam registration, MSME certificate India, small business registration, MSME benefits"
        />

        <link rel="canonical" href="https://e-advisorssolution.com/msme-registration" />

        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "MSME Registration Service",
            provider: {
              "@type": "Organization",
              name: "E-Advisor Solution"
            },
            areaServed: "India",
            description:
              "Professional MSME (Udyam) registration services to help businesses get government recognition and benefits.",
            serviceType: "Business Registration"
          })}
        </script>
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>MSME Registration (Udyam Registration)</h1>
        <p>Get Government Recognition & Unlock Business Benefits</p>
         <button className="hero-btn" onClick={scrollToContact} >
          Get Started Today
        </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <div className="card">
        <p>
          MSME Registration, also known as Udyam Registration, is a government
          recognition for Micro, Small, and Medium Enterprises in India.
        </p>
        <p>
          It helps businesses access subsidies, loans, tax benefits, and various
          government schemes.
        </p>
        <p>
          We provide quick and hassle-free MSME registration services to help
          your business get officially recognized.
        </p>
        </div>
      </section>

      {/* WHO CAN APPLY */}
      <section className="service-section">
        <h2>Who Can Apply?</h2>

        <div className="card-grid">
          <div className="service-card">Manufacturing Businesses</div>
          <div className="service-card">Service-Based Businesses</div>
          <div className="service-card">Startups & SMEs</div>
          <div className="service-card">Traders & Freelancers</div>
          <div className="service-card">Proprietorships</div>
          <div className="service-card">LLPs & Companies</div>
        </div>
      </section>

      {/* CLASSIFICATION */}
      <section className="service-section">
        <h2>Classification of MSME</h2>

        <div className="card-grid">
          <div className="service-card">
            Micro <br /> Investment ≤ ₹1 Cr <br /> Turnover ≤ ₹5 Cr
          </div>
          <div className="service-card">
            Small <br /> Investment ≤ ₹10 Cr <br /> Turnover ≤ ₹50 Cr
          </div>
          <div className="service-card">
            Medium <br /> Investment ≤ ₹50 Cr <br /> Turnover ≤ ₹250 Cr
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of MSME Registration</h2>

        <div className="card-grid">
          <div className="service-card">✔ Government subsidies</div>
          <div className="service-card">✔ Easy bank loans</div>
          <div className="service-card">✔ Collateral-free loans</div>
          <div className="service-card">✔ Protection from delayed payments</div>
          <div className="service-card">✔ Priority in tenders</div>
          <div className="service-card">✔ Tax benefits</div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our MSME Services Include</h2>

        <div className="card-grid">
          <div className="service-card">Eligibility check</div>
          <div className="service-card">Online Udyam filing</div>
          <div className="service-card">Aadhaar & PAN verification</div>
          <div className="service-card">Business classification</div>
          <div className="service-card">Certificate support</div>
          <div className="service-card">Post-registration help</div>
        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>Aadhaar Card</li>
          <li>PAN Card</li>
          <li>Business details</li>
          <li>Address proof</li>
          <li>Bank account details</li>
          <li>Investment & turnover details</li>
        </ul>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>MSME Registration Process</h2>
        <ul>
          <li>Eligibility consultation</li>
          <li>Online application</li>
          <li>Aadhaar OTP verification</li>
          <li>Submission of details</li>
          <li>Certificate generation</li>
        </ul>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="card-grid">
          <div className="service-card">✔ Fast process</div>
          <div className="service-card">✔ Expert assistance</div>
          <div className="service-card">✔ Error-free filing</div>
          <div className="service-card">✔ Affordable pricing</div>
          <div className="service-card">✔ End-to-end support</div>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Get your MSME registration today</h2>
        <p>Unlock government benefits and grow your business faster.</p>
        <button>Contact Us</button>
      </section> */}

          
            <div className="cta" ref={contactRef}>
              <h2>Get your MSME registration today</h2>
              <p>Unlock government benefits and grow your business faster.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default MSMERegistration;